<ds-modal [modal]="modal" [title]="'websites_apps_by_risk_management_status' | translate">
  <app-ngb-table
    id="websites-apps-by-risk-management-status-table"
    [config]="tableConfig$ | async"
    [data]="tableData$ | async"
  ></app-ngb-table>
</ds-modal>
